import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import StarIcon from "@mui/icons-material/Star";
import demoDevoteeImg from "../../../assets/prasad-img.webp";
import "./DashboardFeedback.scss";
import ImageView from "../../ImageView/ImageView";
import TestimonialModal from "../Testimonial/TestimonialModal";
import CustomVideoPlayer from "../../videoPlayer/CustomVideoPlayer";

const DashboardFeedback = ({
  feedbackData,
  pujaDetails,
  selectedTempleDetails,
  className,
  activeVideoId,
  setActiveVideoId,
}: any) => {
  const [reviewModalOpen, setReviewModalOpen] = useState(false);
  const devoteeVideoUrl =
    Array.isArray(feedbackData?.devoteeReviewVideo) &&
    feedbackData.devoteeReviewVideo.length > 0
      ? feedbackData.devoteeReviewVideo[0]?.videoUrl
      : null;
  const videoId = feedbackData?.id;

  const handlePlay = (isPlay: boolean) => {
    if (isPlay) {
      setActiveVideoId(videoId);
    } else {
      setActiveVideoId(null);
    }
  };
  
  return (
    <>
      <Box className={`testimonialCard ${className ?? ""}`}>
        <Box className="testimonialImageWrapper">
          {feedbackData?.userImage?.includes("https") ? (
            <Box className="testimonialImage">
              <ImageView
                src={feedbackData?.userImage}
                alt="Devotee Profile"
                width={50}
                height={50}
                breakpoints={[50]}
                sizes="(max-width: 768px) 40px, 60px"
              />
            </Box>
          ) : (
            <Box className="testimonialImage">
              <img
                src={demoDevoteeImg}
                alt="Devotee Profile"
                width={80}
                height={80}
              />
            </Box>
          )}
        </Box>

        {devoteeVideoUrl ? (
          <Box className="parentBoxVideo">
            <CustomVideoPlayer
              key={devoteeVideoUrl}
              src={devoteeVideoUrl}
              isPlaying={activeVideoId === videoId}
              onClickPlay={handlePlay}
              width="100%"
              height="auto"
            />
          </Box>
        ) : (
          <Box className="parentBox">
            <Typography className="testimonialText">
              {feedbackData?.feedBack ?? ""}
            </Typography>
          </Box>
        )}

        <Box className="testimonialDivider"></Box>
        <Typography className="testimonialName">
          {feedbackData?.userName ?? "Avinash"}
        </Typography>
        <Typography className="testimonialProfession">
          {feedbackData?.userProfession ?? ""}
        </Typography>
        <Typography className="testimonialLocation">
          {feedbackData?.userPlace ?? "Delhi, India"}
        </Typography>
        <Box className="testimonialStars">
          {Array.from({ length: feedbackData?.rating ?? 5 }).map((_, index) => (
            <StarIcon key={index} className="starIcon" />
          ))}
        </Box>
      </Box>

      <TestimonialModal
        open={reviewModalOpen}
        onClose={() => setReviewModalOpen(false)}
        reviewData={feedbackData}
        pujaDetails={pujaDetails}
        selectedTempleDetails={selectedTempleDetails}
      />
    </>
  );
};

export default DashboardFeedback;
